<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { GameStatus as GameStatusType } from './types';

  export let status: GameStatusType = 'playing';
  export let word: string = '';
  export let score: number = 0;

  const dispatch = createEventDispatcher();

  function handlePlayAgain() {
    dispatch('playAgain');
  }

  function handleNewGame() {
    dispatch('newGame');
  }
</script>

{#if status === 'won'}
  <div class="status-card status-won" role="alert" aria-live="polite">
    <div class="status-icon">🎉</div>
    <h2 class="status-title">You Won!</h2>
    <p class="status-message">Amazing! You guessed the word correctly.</p>
    <p class="status-score">Score: {score}</p>
    <div class="status-actions">
      <button class="btn btn-primary" on:click={handlePlayAgain}>
        Play Again
      </button>
    </div>
  </div>
{:else if status === 'lost'}
  <div class="status-card status-lost" role="alert" aria-live="polite">
    <div class="status-icon">💀</div>
    <h2 class="status-title">Game Over</h2>
    <p class="status-message">
      The word was <strong>{word.toUpperCase()}</strong>
    </p>
    <p class="status-score">Score: {score}</p>
    <div class="status-actions">
      <button class="btn btn-primary" on:click={handlePlayAgain}>
        Try Again
      </button>
    </div>
  </div>
{/if}

<style>
  .status-card {
    text-align: center;
    padding: 30px 20px;
    border-radius: 16px;
    animation: statusAppear 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    max-width: 400px;
    margin: 0 auto;
  }

  .status-won {
    background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
    border: 2px solid #66bb6a;
  }

  .status-lost {
    background: linear-gradient(135deg, #ffebee, #ffcdd2);
    border: 2px solid #ef5350;
  }

  .status-icon {
    font-size: 48px;
    margin-bottom: 10px;
  }

  .status-title {
    font-size: 28px;
    font-weight: 800;
    margin: 0 0 8px;
    color: #2c3e50;
  }

  .status-message {
    font-size: 16px;
    color: #555;
    margin: 0 0 4px;
  }

  .status-score {
    font-size: 14px;
    color: #777;
    margin: 0 0 16px;
  }

  .status-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
  }

  .btn {
    padding: 10px 28px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .btn-primary {
    background: #4a90d9;
    color: white;
  }

  .btn-primary:hover {
    background: #357abd;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(74, 144, 217, 0.3);
  }

  @keyframes statusAppear {
    0% {
      transform: scale(0.5) rotate(-5deg);
      opacity: 0;
    }
    100% {
      transform: scale(1) rotate(0deg);
      opacity: 1;
    }
  }
</style>
